import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";


export interface ITarget {
    id: number
    title: string
    icon: string
    colorBorder?: any
    bgColor?: any
    colorText?: any
    timestamp?: string
    isVoucher: boolean
    status: boolean
}

// active

export const activeTarget = async (
    id: number,
) => {
    const url = `target/activeTarget`;
    const params = { id }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        url, params
    );
    return result;
}


//Danh sách mục tiêu
export const getListTarget = async () => {
    const path = "target/listTarget";
    const result: ResponseSuccess<ITarget[]> = await axiosClient.get(path, {});
    return result;
};

// thêm mục tiêu
export const addListTarget = async (
    title: string, icon: File,
    colorBorder?: string, bgColor?: string, colorText?: string
) => {
    const url = `target/addTarget`;
    const params = {
        title, icon, colorBorder, bgColor, colorText
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, params
    );
    return result;
}

// cập nhật mục tiêu
export const editTarget = async (
    id: number, title: string, icon: File,
    colorBorder?: string, bgColor?: string, colorText?: string
) => {
    const url = `target/editTarget`;
    const params = { id, title, icon, colorBorder, bgColor, colorText }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        url, params
    );
    return result;
}



export const delTarget = async (id: number) => {
    const url = `target/delTarget`;
    const params = {
        id
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, params
    );
    return result;
}

export const getInfoTarget = async (id: number) => {
    const url = `target/infoTarget`;
    const params = {
        id
    }
    const result: ResponseSuccess<ITarget> = await axiosClient.get(
        url, { params }
    );
    return result;
}